import { DOMHelper } from "./dom-helper";
import { MarketingClientConstants } from "../constants/marketing-client-constants";
export class PageInformationHelper {
    static getArticleId() {
        var _a;
        return (_a = DOMHelper.querySelector(MarketingClientConstants.rootElement)) === null || _a === void 0 ? void 0 : _a.getAttribute("data-xx");
    }
}
